<h2>
  <span>{{
    (
    filter_service.filtersType[1].options.options_selected_subject.asObservable()
    | async
    )?.name | transloco
    }}
    {{
    (
    filter_service.filtersType[5].options.options_selected_subject.asObservable()
    | async
    )?.name | transloco
    }}
  </span>
</h2>
<table class="wa-table">
  <thead class="wa-table__header-group">
    <tr class="wa-table__row">
      <th></th>
      <th class="h-ranking sortable wa-table__cell" [ngClass]="sortClass('NAME')" (click)="changeSort('NAME')">
        <span>{{'Name' | transloco}}</span>
      </th>
      <th class="h-name sortable wa-table__cell" [ngClass]="sortClass('NOC')" (click)="changeSort('NOC')">
        <span>
          {{'Location' | transloco}}
        </span>
      </th>

      <th class="h-points sortable wa-table__cell" [ngClass]="sortClass('DATE')" (click)="changeSort('DATE')">
        <span>{{'Date' | transloco}}</span>
      </th>
      <th></th>
      <th></th>
    </tr>
  </thead>

  <ng-container *ngIf="data.length > 0 else: noresults">
    <tbody class="wa-table__row-group" *ngFor="let Event of data" [Event]="Event" app-calendar-table class="wa-table__row-group">
    </tbody>
  </ng-container>

  <ng-template #noresults>
    <tbody class="wa-table__row-group">
      <div *ngIf="model.loadingRef===false" class="status-message status-message--info">{{'no_results' | transloco}} {{(defaultValueMessage|async) | transloco}}</div>
    </tbody>
  </ng-template>
</table>

<div class="status-message status-message--info" *ngIf="model.loadingRef === true; else: button" class="loading-throbber"></div>
<ng-template #button>
  <div [ngClass]="'load-more-full'" *ngIf="
  (pagination != undefined &&
  data.length !== pagination.totalResults)
  && pagination.totalResults !== 0
  "
    (click)="loadMore()">
    {{'load_more' | transloco}}
  </div>
</ng-template>

<hr class="spacer" />
<!--
<div *ngIf="loading===false && RankingList!==undefined &&  RankingList.length===0" class="status-message status-message--info">{{'no_results' | transloco}}</div>
<ng-template *ngIf="loading===true" #noresults> <div class="status-message status-message--info">{{'no_results' | transloco}}</div> </ng-template>
-->
